export default function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {},
        template: `
            <section class="tabs">

                <div class="tab-btns">
                    <a ng-repeat="title in tabs.titles"
                        ng-click="tabs.setActiveTab($index)"
                        ng-class="{ 'active' : tabs.isTabActive($index) }"
                        href="">
                        {{ title }}
                    </a>

                </div>

                <ng-transclude></ng-transclude>

            </section>
        `,
        controller: tabsCtrl,
        controllerAs: 'tabs'
    };
}

function tabsCtrl($element, $compile, $scope) {
    this.titles = [];
    this.activeTab = 0;

    /* --- */

    this.addTab = addTab;
    this.setActiveTab = setActiveTab;
    this.isTabActive = isTabActive;

    /* --- */

    function addTab(title, content) {
        const tabEl = createTab(this.titles.length, content);

        $element.append(tabEl);
        this.titles.push(title);
    }

    function setActiveTab(index) {
        this.activeTab = index;
    }

    function isTabActive(index) {
        return this.activeTab === index;
    }

    function createTab(index, el) {
        const wrapEl = $compile(`
            <div class="tab-content" ng-show="tabs.isTabActive(${ index })">

            </div>
        `)($scope);

        wrapEl.append(el);
        return wrapEl;
    }
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/tabs.js